module.exports = __webpack_public_path__ + "img/Manage Users.14d4ed3e.svg";